import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { HRM2130_R01Dto } from "./Dto_HRM2130_R01";
import { HRM2130_R01Filter } from "./Store_HRM2130_R01";

// 모든 HRM2130_R01 요청의 공통 API 경로이다.
const baseUrl = `${config.apiUrl}/HRM2130_R01`;

/**
 * 검색 또는 저장 후 재조회 조건으로 근태코드 목록을 가져온다.
 * @param option search 또는 refetch 경로
 * @param params 근태구분·사용여부·근태명 조건
 * @param listLength 요청에 포함하지만 현재 백엔드 목록 쿼리에서는 사용하지 않는 목록 길이
 * @returns 근태코드 배열을 담은 서버 응답
 */
export const getHRM2130_R01List = async (option: string, params: Partial<HRM2130_R01Filter>, listLength: number = 0) =>
    await getData<ResponseDto<HRM2130_R01Dto[]>>(`${baseUrl}/${option}`, { params: { ...params, listLength } });

/** 같은 검색 조건에 해당하는 전체 건수를 담은 서버 응답을 반환한다. */
export const getHRM2130_R01AllCount = async (params: Partial<HRM2130_R01Filter>) =>
    await getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: { ...params } });

/** 신규 행 목록을 등록하고 저장된 근태코드 목록 응답을 반환한다. */
export const postHRM2130_R01 = async (data: HRM2130_R01Dto[]) =>
    await postData<HRM2130_R01Dto[], ResponseDto<HRM2130_R01Dto[]>>(baseUrl, data);

/** 수정 행 목록을 반영하고 저장된 근태코드 목록 응답을 반환한다. */
export const patchHRM2130_R01 = async (data: HRM2130_R01Dto[]) =>
    await patchData<HRM2130_R01Dto[], ResponseDto<HRM2130_R01Dto[]>>(baseUrl, data);

/** 쉼표로 연결한 근태코드들을 URL 인코딩해 삭제하고 완료 응답을 반환한다. */
export const deleteHRM2130_R01 = async (attendCd: string) =>
    await deleteData<ResponseDto<void>>(`${baseUrl}/${encodeURIComponent(attendCd)}`);

/** 조회와 같은 조건의 Excel 데이터를 요청하고 인코딩된 파일 응답을 반환한다. */
export const downloadExcel_HRM2130_R01 = async (option: string, params: Partial<HRM2130_R01Filter>, listLength: number = 0) =>
    await getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, { params: { ...params, listLength } });
